<template>
    <div class="man-page">
        <flickity-box class="flickity" ref="flickity" :options="flickityOptions">
            <div class="carousel-cell" v-for="n in 6">
                <img :src="require('../assets/man_glove_' + n +'.png')" />
            </div>
        </flickity-box>
    </div>
</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    data() {
      return {
        flickityOptions: {
          freeScroll: false,
          imagesLoaded: true,
          wrapAround: true,
        },
      };
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/ManPage.vue